import CreateAdWatch from './CreateAdWatch'

export default CreateAdWatch
